export class FetchMyNotificationsList {
  static readonly type = "[Notifications] Fetch My Notifications";
  constructor() {}
}
